import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";

import store from "./store";

/*
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: 'd0c48d14-9023-440a-99b1-c2e45558f7f9',
    clientToken: 'pub7de8ec306b4e2f75a3fb9727320c4310',
    site: 'datadoghq.com',
    service:'install',
    env:'PROD',
    // Specify a version number to identify the deployed version of your application in Datadog 
    // version: '1.0.0', 
    sessionSampleRate:100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel:'mask-user-input'
});    
datadogRum.startSessionReplayRecording();
*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
